import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

declare var $: any;

@Injectable()
export class ChatEventService {

    private contactSource = new BehaviorSubject<any>(null);
    contact$ = this.contactSource.asObservable();

    private conversationSource = new BehaviorSubject<any>(null);
    conversation$ = this.conversationSource.asObservable();

    private userSource = new BehaviorSubject<any>(null);
    user$ = this.userSource.asObservable();

    private toggleSource = new BehaviorSubject<any>(null);
    toggle$ = this.toggleSource.asObservable();

    private contactTypeSource = new BehaviorSubject<any>(null);
    contactType$ = this.contactTypeSource.asObservable();

    private groupEventSource = new BehaviorSubject<any>(null);
    groupEvent$ = this.groupEventSource.asObservable();

    private modalEventSource = new BehaviorSubject<({ type: string, data: any })>(null);
    modalEvent$ = this.modalEventSource.asObservable();

    private friendRequestSource = new BehaviorSubject<number>(null);
    friendRequest$ = this.friendRequestSource.asObservable();

    private renameConvEventSource = new BehaviorSubject<any>(null);
    renameConvEvent$ = this.renameConvEventSource.asObservable();


    constructor() {
    }

    sendContact(data: any) {
        this.contactSource.next(data);
    }

    sendConversation(data: any) {
        this.conversationSource.next(data);
    }

    sendUser(data: any) {
        this.userSource.next(data);
    }

    toggle(data: any) {
        this.toggleSource.next(data);
    }

    sendContactType(data: any) {
        this.contactTypeSource.next(data);
    }

    /**
     * data = 0: create group
     * data = 1: view group members
     * data = 2: add group member
     * data = 3: add group member with current conversation
     * @param data 
     */
    sendGroupEvent(data: any) {
        this.groupEventSource.next(data);
    }

    sendModalEvent(data: ({ type: string, data: any })) {
        this.modalEventSource.next(data);
    }

    sendFriendRequestEvent(data: number) {
        this.friendRequestSource.next(data);
    }

    sendRenameConvEvent(data: number) {
        this.renameConvEventSource.next(data);
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/services/chat-event.service.ts